module.exports = __webpack_public_path__ + "img/pin-angle.abed879d.svg";